import Vue from "vue"
import VueRouter from "vue-router"
import login from './modules/security'
import {getToken,removeToken} from '@/utils/auth'
import {isValueEmpty} from '@/utils/is-rules'
import user from "./modules/user"
import staff from "./modules/staff"
import student from "./modules/student"
import promote from "./modules/promote"
import question from "./modules/question"
import report from "./modules/report"
import evaluate from "./modules/evaluate"
import returnProblem from "./modules/returnProblem"
import setting from "./modules/setting"
import practice from "./modules/practice"
import job from "./modules/job"
import studentJob from "./modules/studentJob"
import branchStudentNumber from "./modules/branchStudentNumber"
import topic from "./modules/topic"
import personal_information from "./modules/personal-information"
import card from "./modules/card"
import data_dictionary from "./modules/data_dictionary"
import order from "./modules/order"
import coin from "./modules/coin"
import store from '@/store'
Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    redirect: '/user',
    component: () => import('@/layout/index'),
    children: [
      ...user,
      ...staff,
      ...student,
      ...topic,
      ...promote,
      ...job,
      ...studentJob,
      ...order,
      ...evaluate,
      ...returnProblem,
      ...practice,
      ...question,
      ...personal_information,
      ...report,
      ...data_dictionary,
      ...setting,
      ...branchStudentNumber,
      ...login,
      ...card,
      ...coin,
    ]
  },
  {
    path: '/answer-record-detail',
    component: () => import('@/views/student/examinationAnswerResult') // 直接渲染组件
  },
  {
    path: '*',
    component: () => import('@/views/404')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

const whitelist = [
  '/login', '/ligature','/answer-record-detail'
]

router.beforeEach(async (to, from, next) => {

  if (getToken()) {
    if (to.path === '/login') {
      next({
        path: '/'
      })
    } else {
      if(isValueEmpty(store.getters.adminUserInfo?.roleId)){
         removeToken();
         next({
          path: '/login'
        })
      }
      if(store.getters.adminUserInfo.roleId == 2 && (to.meta.menuActive == '/staff' ||to.meta.name == '/studentEdit' || to.path == '/evaluate' || to.path == '/topic' || to.path == '/practice' || to.path == '/question')){
        next({
          path: '/studentJob'
        })
      }
      if((store.getters.adminUserInfo.roleId == 3) && to.meta.menuActive == '/staff'){
        next({
          path: '/evaluate'
        })
      }else{
        next()
      }
    }
  } else {
    if (whitelist.includes(to.path)) {
      next()
    } else {
      next({
        path: '/login'
      })
    }
  }
  
})

export default router